var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import { getThemeStyle, useTheme } from '@citrus/user';
import { actionButton, actionButtonLeft, numberStepper } from '../styles/legacy';
import { actionButton as actionButtonCitrus2022, actionButtonLeft as actionButtonLeftCitrus2022, numberStepper as numberStepperCitrus2022, } from '../styles/citron';
import { cx, css as emotionCss } from 'emotion';
import { BorderlessButton } from '@citrus/button';
import { Icon } from '@citrus/icon';
import { citrusStyled } from '@citrus/runtime';
export var ComponentWrapper = citrusStyled.div('numberStepper', {
    legacy: numberStepper,
    citrus2022: numberStepperCitrus2022,
});
export var MinusButton = function (_a) {
    var disabled = _a.disabled, other = __rest(_a, ["disabled"]);
    var theme = useTheme();
    var style = useCallback(function (legacy, citrus2022) {
        return getThemeStyle(theme, { legacy: legacy, citrus2022: citrus2022 });
    }, [theme]);
    return (React.createElement(BorderlessButton, __assign({ className: cx(emotionCss(style(actionButtonLeft, actionButtonLeftCitrus2022))), disabled: disabled }, other),
        React.createElement(Icon, { "aria-hidden": true, name: "minus", title: "minus" })));
};
export var PlusButton = function (_a) {
    var disabled = _a.disabled, other = __rest(_a, ["disabled"]);
    var theme = useTheme();
    var style = useCallback(function (legacy, citrus2022) {
        return getThemeStyle(theme, { legacy: legacy, citrus2022: citrus2022 });
    }, [theme]);
    return (React.createElement(BorderlessButton, __assign({ className: cx(emotionCss(style(actionButton, actionButtonCitrus2022))), disabled: disabled }, other),
        React.createElement(Icon, { "aria-hidden": true, name: "plus", title: "plus" })));
};
export var Styled = {
    ComponentWrapper: ComponentWrapper,
    MinusButton: MinusButton,
    PlusButton: PlusButton,
};
